import useDeleteFolder from '@/api/mutations/folders/useDeleteFolder';
import { TFolder } from '@/api/queries/project/useGetProjectFolders';
import { Button, Modal, ModalProps } from '@payaca/ambrosia';

import { FC } from 'react';

export type TProps = {
  projectId?: string;
  folder?: TFolder;
} & Pick<ModalProps, 'isOpen' | 'onClose'>;

const DeleteFolderModal: FC<TProps> = (props) => {
  const { projectId, folder, isOpen, onClose } = props;

  const { mutateAsync: deleteFolderMutation } = useDeleteFolder({
    projectId,
  });

  const handleConfirm = async () => {
    if (!folder) {
      return;
    }

    try {
      await deleteFolderMutation({ id: folder.id });
      onClose?.();
    } catch (error) {
      console.error('Failed to delete folder:', error);
    }
  };

  return (
    <Modal title="Delete folder" isOpen={isOpen} onClose={onClose}>
      <Modal.Body>
        <p>
          Are you sure you want to delete the folder {'"'}
          {folder?.name}
          {'"'}? This action cannot be undone.
        </p>
      </Modal.Body>

      <Modal.Footer>
        <Modal.Footer.Actions>
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button colour="red" onClick={handleConfirm}>
            Delete
          </Button>
        </Modal.Footer.Actions>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteFolderModal;
